export { networkCapturePlugin as plugin, networkCapturePlugin } from './network-capture-plugin';
//# sourceMappingURL=index.js.map